import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

class Popup1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            domainURL: props.config.DomainURL != "" ? props.config.DomainURL : "https://producermax.com/",
        };
    }

    handleClose() {
        // this.props.alertPopUpResult(this.props.help);
        window.location.href = this.state.domainURL;
    }

    render() {
        return (
            <div>
                <div style={{ position: "fixed" }} >
                    <Modal show="show" size={"sm"}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        {/*
                            <Modal.Header>
                                <Modal.Title><h5 className="alertTitle">{"Success"}</h5></Modal.Title>
                            </Modal.Header>
                        
                         <div style={{ height: "395px", width: "100%", overflow: "auto", position: "relative" }}> */}
                        <Modal.Body className="alertAgentDtls">

                            <div>
                                < h6 > Thank you for Submitting the SOA form.</h6>
                                <h6>You can close the browser now.</h6>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="warning" onClick={this.handleClose.bind(this)}>
                                {"Ok"}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div >
        );
    }
}
export default Popup1;